<template>
  <div style="display:none;"></div>
</template>

<script>
  export default {
    data() {
      return {
        param: {
          vdnId: '',
          authToken: '',
          webSocketURL: ''
        },
        uuid: '', //每次发送都要重新生成
        wsObj: null,
        sendObj: null,
        sendTime: 5000, //心跳包发送间隔
        sendNum: 0, //心跳包发送次数，收到回复清零，未收到回复 +1
        sendMax: 4, //心跳包发送最大次数，超出此数判定链接中断，需重连
        reOgj: null,
        reTime: 5000, //重连间隔
        logoutStatus: false
      };
    },
    created() {},
    mounted() {
      this.initVdnId()
      this.wsLoginFn()
    },
    beforeDestroy(){
      if(this.wsObj){
        this.wsObj.close()
      }
    },
    methods: {
      initVdnId(){
        let obj = JSON.parse(LocalStorage.getItem("obj"))
        if(obj){
          this.param.vdnId = obj.vdnId
          this.param.authToken = obj.authToken.replace('Bearer ', '')
          this.param.webSocketURL = window.WSSET.wsMsgUrl + '?vdnId=' + obj.vdnId
        }

        this.sendTime = window.WSSET.sendTime
        this.sendMax = window.WSSET.sendMax
        this.reTime = window.WSSET.reTime

        if(SessionStorage.getItem('notAutoLogin')){
          SessionStorage.removeItem('notAutoLogin');
        }
      },
      //websocket登录
      wsLoginFn(){
        window.WebSocket = window.WebSocket || window.MozWebSocket;
        if(window.WebSocket != undefined){
          this.connect(); //连接websocket
        } 
      },
      //连接
      connect(){
        if(!this.wsObj){
          this.wsObj = new WebSocket(this.param.webSocketURL)

          //连接打开
          this.wsObj.onopen = () => {
            this.uuid = this.UUID()
            let params = {
              uuid: this.uuid,
              method: 'Ag_Login',
              authToken: this.param.authToken,
              vdnId: this.param.vdnId
            }
					  this.wsObj.send(JSON.stringify(params));
          }

          //连接关闭
          this.wsObj.onclose = () => {
            //尝试停止心跳包
            try{
              clearInterval(this.sendObj)
              this.sendObj = null
              this.sendNum = 0
            }catch(e){}

            this.wsObj = null //关闭当前的连接
            if(!this.reOgj && !this.logoutStatus){
              this.reConnect() //定时器不存在并且不是通过退出触发的关闭才重新连接
            }
            this.logoutStatus = false //重置退出状态
          }

          //连接出错
          this.wsObj.onerror = () => {
            console.error('信息公告websocket连接出错')
          }

          //连接收到返回信息
          this.wsObj.onmessage = (event) => {
            let webSockData = event.data;
            if (webSockData == "welcome to webSock!") {
              return false;
            }
            let res = JSON.parse(webSockData)

            if(res.retCode == 1){
              //连接登录成功
              if(res.method == 'Ag_LoginAck'){
                //成功后尝试停止重连定时器
                try{
                  clearInterval(this.reOgj)
                  this.reOgj = null
                }catch(e){}

                this.heartbeat() //发送心跳包
              }

              //心跳包保活成功
              if(res.method == 'Ag_HeartBeatAck'){
                this.sendNum = 0 //重置为0
              }
            }else if(res.retCode == 2){
              if(res.method == 'Ag_LoginAck'){
                this.tokenLogoutFn();
              }
            }else if(res.retCode == 114){
              if(res.method == 'Ag_LoginAck'){
                //通过ws 114退出系统的，不走润工作自动登录流程
                SessionStorage.setItem('notAutoLogin', 1);
                this.tokenLogoutFn();
              }
            }

            //菜单数量显示
            if(res.method == 'Ag_MenuEvt'){
              let name = res.menuName
              let qty = res.qty
              let type = res.type //该次数量变化的类型 all所有、add增加、read减少
              this.reSetMenuNumFn(name, qty, type)
            }

            //公告提示
            if(res.method == 'Ag_NoticeEvt'){
              this.$emit('noticObj', res) //返回公告对象
              if(res.recId){
                //有推送消息
                this.createWebTips(res.title, '公告消息', 1)
              }
            }

            //通知提示
            if(res.method == 'Ag_TipsEvt'){
              this.$emit('msgObj', res) //返回通知对象
              if(res.recId){
                //有推送消息
                this.createWebTips(res.title, '提示消息', 1)
              }
            }

          }
          //-----end------
        }
      },
      //通过ws退出系统
      tokenLogoutFn(){
        //token过期了，直接退到登录界面
        try{
          clearInterval(this.reOgj)
          this.reOgj = null
        }catch(e){}

        //退出登录
        let hotTabArr = LocalStorage.getItem('hotTabArr');
        let record_extnum = LocalStorage.getItem('record_extnum');
        LocalStorage.clear();
        SessionStorage.clear()
        if(hotTabArr){
          LocalStorage.setItem('hotTabArr', hotTabArr);
        }
        if(record_extnum){
          LocalStorage.setItem('record_extnum', record_extnum);
        }
        if(this.bodyBgColor){
          LocalStorage.setItem('bodyBgColor', this.bodyBgColor)
        }
        if(this.isOpenCallTip){
          LocalStorage.setItem('isOpenCallTip', this.isOpenCallTip)
        }
        let Lang = '';
        if(window.location.href.indexOf('?') > -1){
          Lang = window.location.href.split('?')[1];
        }
        if(Lang && Lang.indexOf('vdnId') > -1){
          this.$router.push("/?" + Lang);
        }else{
          this.$router.push("/?vdnId=" + this.param.vdnId + (Lang?'&' + Lang:''));
        }
        this.$store.commit("navTabs/LOGOUT");
        window.location.reload()
      },
      //心跳包
      heartbeat(){
        this.sendObj = setInterval(()=>{
          this.uuid = this.UUID()
          let params = {
            uuid: this.uuid,
            method: 'Ag_HeartBeat',
            token: this.param.authToken,
            vdnId: this.param.vdnId
          }
          this.wsObj.send(JSON.stringify(params));

          this.sendNum = this.sendNum + 1 //累计加1
          if(this.sendNum >= this.sendMax){
            //发送次数大于设定最大值，清空心跳定时器
            clearInterval(this.sendObj)
            this.sendObj = null
            this.sendNum = 0
            //发送重连信息
            this.reConnect()
          }

        }, this.sendTime)
      },
      //重连
      reConnect(){
        this.reOgj = setInterval(()=>{
          this.connect()
        }, this.reTime)
      },
      //通过退出登录正常关闭连接 - 不再重连
      closeWS(){
        this.logoutStatus = true
        if(this.wsObj){
          this.wsObj.close()
        }else{
          try{
            clearInterval(this.reOgj)
            this.reOgj = null
          }catch(e){}
        }
      },
      //更新菜单待办数量显示
      reSetMenuNumFn(name, qty, type){
        let menuList = this.$store.state.navTabs.menuList
        let newMenuList = this.reMenuListFn(menuList, name, qty, type)
        this.$store.state.navTabs.menuList = newMenuList
        if (name == '我的未解决工单') {
          let unresolvedNum = this.$store.state.navTabs.unresolvedNum

          //全
          if(type == 'all') unresolvedNum = qty
          //加
          else if(type == 'add') unresolvedNum = (unresolvedNum + qty)
          //减
          else unresolvedNum = (unresolvedNum - qty)
          
          this.$store.state.navTabs.unresolvedNum = unresolvedNum
        }
        if (name == '组内未解决工单') {
          let groupUnResolvedNum = this.$store.state.navTabs.groupUnResolvedNum

          //全
          if(type == 'all') groupUnResolvedNum = qty
          //加
          else if(type == 'add') groupUnResolvedNum = (groupUnResolvedNum + qty)
          //减
          else groupUnResolvedNum = (groupUnResolvedNum - qty)
          
          this.$store.state.navTabs.groupUnResolvedNum = groupUnResolvedNum
        }
      },
      reMenuListFn(menuList, name, qty, type){
        let result = menuList;
        for (let i in result) {
          let item = result[i];
          if (item.name == name) {
            let oldQty = item.qty?item.qty:0
            if(type == 'all'){
              //全
              this.$set(item, 'qty', qty)
            }else if(type == 'add'){
              //加
              this.$set(item, 'qty', oldQty + qty)
            }else{
              //减
              this.$set(item, 'qty', oldQty - qty)
            }
            break;
          } else if (item.children && item.children.length > 0) {
            item.children = this.reMenuListFn(item.children, name, qty, type);
          }
        }
        return result;
      },
    }
  };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// MessageWS.vue?4d40ac58